// extracted by mini-css-extract-plugin
export default {"breadcrumb":"yh-z","breadcrumbItem":"zh-z"};